export default "__VITE_ASSET__ChVZ70E2__"